// extracted by mini-css-extract-plugin
export default {"main":"style_main__Xp9eg","start":"style_start__cPGM3"};